import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorHandler, HandleError } from '../http-error-handler.service';
import { AuthService } from '../core/authentication/auth.service';
import { DatePipe } from '@angular/common';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UrlApi } from '../shared/enums/urlApi';
import { Consolidado } from '../shared/models/cierreTurno/Consolidado';
import { CierreTurnoService } from '../cierreTurno/cierre-turno.service';
import { ResolucionMensual } from '../shared/models/cierreTurno/ResolucionMensual';

@Injectable({
  providedIn: 'root'
})
export class ReportesService
{
  cierreTurnoBase = environment.apiServer.cierreTurnoBaseUrl;
  private cierreURL = this.cierreTurnoBase + '/CierresTurnosV1/';
  private resolucionURL = this.cierreTurnoBase + '/Resolucion/';
  baseUrl = environment.apiServer.reportesUrl;
  private handleError: HandleError;

  constructor(private http: HttpClient, 
    httpErrorHandler: HttpErrorHandler)
  {
    this.handleError = httpErrorHandler.createHandleError('Reportes');
  }

  obtenerReporteConsoldiado(codigoProducto:string, fdesde: string, fhasta:string): Observable<Consolidado[]> {
    return this.http.get<Consolidado[]>(this.cierreURL + 'Consolidado?codigoProducto='+codigoProducto + '&fechaDesde=' + fdesde + '&fechaHasta=' + fhasta);
  }

  obtenerResolucionMensual(codigoProducto:string, fdesde: string, fhasta: string): Observable<ResolucionMensual> {
    return this.http.get<ResolucionMensual>(this.resolucionURL + `resolucion/${codigoProducto}/${fdesde}/${fhasta}`);
  }
  
  guardarResolucionMensual(body:ResolucionMensual): Observable<ResolucionMensual> {
    return this.http.post<ResolucionMensual>(this.resolucionURL + `generarResolucion`, body);
  }

  base64ToArrayBuffer(base64) {
    let binaryString = atob(base64);
    let bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer
  }
}